import ScrollMagic from 'ScrollMagic/scrollmagic/uncompressed/ScrollMagic.js';

export class Animations {

    constructor(settings = {}) {
        this.settings = settings;
        this.controller = new ScrollMagic.Controller();
        this.controllerClassToggles = new ScrollMagic.Controller({ globalSceneOptions: { }});
        this.controllerText = new ScrollMagic.Controller();
        this.controllerTeam = new ScrollMagic.Controller();
    }

    init() { 
        this.navAnim();
        this.classToogles();
        // this.textAnim();
        this.teamAnim();
        this.scrollTo();
    }

    navAnim() {

        let scene = new ScrollMagic.Scene({ triggerElement: ".js-pin" })
            .setPin(".js-pin")
            .addTo(this.controller);
        scene.triggerHook("onLeave");

    }

    teamAnim() {
        const self = this;

        $('.js-team-member').each(function() {

            let tween = TweenMax.to($(this).find('figcaption'), 3, { rotation: 360 });

            // build scene
            let scene = new ScrollMagic.Scene({
                triggerElement: this,
                duration: '100%',
                offset: 100
            })
                .setTween(tween)
                .addTo(self.controllerTeam);

            scene.triggerHook("onEnter");

        });

    }

    classToogles() {
        // build scenes
        new ScrollMagic.Scene({ triggerElement: ".js-sec-1", duration: $('.js-sec-1').outerHeight() })
            .setClassToggle(".js-nav-1", "is-active") // add class toggle
            .addTo(this.controllerClassToggles);
        new ScrollMagic.Scene({triggerElement: ".js-sec-2", duration: $('.js-sec-2').outerHeight()})
            .setClassToggle(".js-nav-2", "is-active") // add class toggle
            .addTo(this.controllerClassToggles);
        new ScrollMagic.Scene({triggerElement: ".js-sec-3", duration: $('.js-sec-3').outerHeight()})
            .setClassToggle(".js-nav-3", "is-active") // add class toggle
            .addTo(this.controllerClassToggles);
        new ScrollMagic.Scene({triggerElement: ".js-sec-4", duration: $('.js-sec-4').outerHeight()})
            .setClassToggle(".js-nav-4", "is-active") // add class toggle
            .addTo(this.controllerClassToggles);
        new ScrollMagic.Scene({triggerElement: ".js-sec-5", duration: $('.js-sec-5').outerHeight()})
            .setClassToggle(".js-nav-5", "is-active") // add class toggle
            .addTo(this.controllerClassToggles);

    }

    textAnim() { 
        const self = this;
        $('.js-text').each(function() {
            let tween = TweenMax.to(this, 0.5, { x: "-=110%" });
            // build scene
            let scene = new ScrollMagic.Scene({
                triggerElement: this,
                duration: '100%',
                offset: 0
            })
                .setTween(tween)
                .addTo(self.controllerText);

            scene.triggerHook("onEnter");
        });
    }

    scrollTo() {
        $('.js-scroll-to-btn').on('click touchstart', (ev) => {
            ev.preventDefault();

            if(ev.isTrigger) {
                return false;
            }

            let offset = 0;
            const scroolToAnchor = $(ev.currentTarget).attr('data-target'),
                scrollToOffset = 0,
                scrollToOffsetHeader = $('.c-navigation').outerHeight();

            if (scrollToOffset) {
                offset = scrollToOffset;
            }

            if ($(ev.currentTarget).attr('data-offset') === 'true') {
                offset = scrollToOffsetHeader;
            }

            if ($(scroolToAnchor).length) {
                TweenMax.to($('html, body'), 1, {
                    scrollTop: $(scroolToAnchor).offset().top - offset,
                    ease: Power2.easeOut
                });
            }
        });
    }
    
    testC() {

    }

}



// WEBPACK FOOTER //
// ./static/js/components/Animations.js